import { Auth } from "aws-amplify";
import toast from "react-hot-toast";

const TOAST_ID_INVALID_CLIENT = "invalid-client-error";
const TOAST_ID_FORBIDDEN = "forbidden-error";

/** Dismisses any persistent error toast. */
export const dismissErrorToast = () => {
  toast.dismiss(TOAST_ID_INVALID_CLIENT);
  toast.dismiss(TOAST_ID_FORBIDDEN);
};

/**
 * Shown when the user navigates to a client they don't have access to.
 * Offers a "Sign out" button so they aren't stuck, and a dismiss (×) so they can
 * still interact with the rest of the page (topbar, sign-out menu, etc.).
 */
export const handleInvalidClientIdError = () => {
  toast(
    (t) => (
      <div className="flex flex-col gap-3 min-w-[18rem] max-w-sm">
        <div className="flex items-start justify-between gap-3">
          <p className="text-sm font-medium text-white leading-snug">
            You do not have access to this client. Please reach out to the Axle
            team to set up client access.
          </p>
          <button
            onClick={() => toast.dismiss(t.id)}
            className="flex-shrink-0 text-white/60 hover:text-white text-lg leading-none transition-colors"
            aria-label="Dismiss"
          >
            ×
          </button>
        </div>
        <div className="flex gap-2">
          <button
            onClick={async () => {
              toast.dismiss(t.id);
              await Auth.signOut();
            }}
            className="flex-1 text-xs font-semibold bg-white text-red-600 rounded px-3 py-1.5 hover:bg-red-50 transition-colors"
          >
            Sign out
          </button>
          <button
            onClick={() => toast.dismiss(t.id)}
            className="flex-1 text-xs font-semibold bg-white/20 text-white rounded px-3 py-1.5 hover:bg-white/30 transition-colors"
          >
            Dismiss
          </button>
        </div>
      </div>
    ),
    {
      id: TOAST_ID_INVALID_CLIENT,
      duration: Infinity,
      style: {
        background: "#dc2626", // red-600
        color: "#fff",
        borderRadius: "0.5rem",
        padding: "1rem",
        maxWidth: "24rem",
      },
    }
  );
};

/**
 * Shown when the user doesn't have access to a specific resource (403).
 * Offers a link back to the dashboard home and a close button.
 */
export const handleForbiddenError = () => {
  toast(
    (t) => (
      <div className="flex flex-col gap-3 min-w-[18rem] max-w-sm">
        <div className="flex items-start justify-between gap-3">
          <p className="text-sm font-medium text-white leading-snug">
            You do not have access to this resource.
          </p>
          <button
            onClick={() => toast.dismiss(t.id)}
            className="flex-shrink-0 text-white/60 hover:text-white text-lg leading-none transition-colors"
            aria-label="Dismiss"
          >
            ×
          </button>
        </div>
        <div className="flex gap-2">
          <button
            onClick={() => {
              toast.dismiss(t.id);
              window.location.href = "/";
            }}
            className="flex-1 text-xs font-semibold bg-white text-red-600 rounded px-3 py-1.5 hover:bg-red-50 transition-colors"
          >
            Go to dashboard
          </button>
          <button
            onClick={() => toast.dismiss(t.id)}
            className="flex-1 text-xs font-semibold bg-white/20 text-white rounded px-3 py-1.5 hover:bg-white/30 transition-colors"
          >
            Dismiss
          </button>
        </div>
      </div>
    ),
    {
      id: TOAST_ID_FORBIDDEN,
      duration: Infinity,
      style: {
        background: "#dc2626",
        color: "#fff",
        borderRadius: "0.5rem",
        padding: "1rem",
        maxWidth: "24rem",
      },
    }
  );
};
